export const FilesHelper = {
  checkExtension (file, exts) {
    if (file && exts) {
      const extensions = (typeof exts === "string") ? [exts] : exts

      return extensions.includes(file.name.split(".").pop())
    }
    return false
  },
  checkSize (file, limitSize) {
    return file && limitSize ? file.size / 1024 <= limitSize : false
  },
  async checkDimensions (file, minRes = 256, maxRes = 3000) {
    const img = document.createElement("img")

    await (img.src = file)

    return img.width >= minRes && img.height >= minRes && img.width <= maxRes && img.height <= maxRes
  },
  async checkResolutions (file, width, height) {
    const img = document.createElement("img")

    await (img.src = file)

    return img.width <= width && img.height <= height
  },
}
